import { constants } from '../constants/socketio.constants';
import { io } from "socket.io-client";

export const actions = {
    connect,
    disconnect,
};

function connect({user}) { 
  return (dispatch, getState) => {

    dispatch({
      type: constants.SOCKETIO_ON_CONNECT,
      undefined,
    });

    /*
    const preio = getState().socketioStore.io;
    if(preio&&preio.connected) preio.disconnect()

    /// https://dispex.org:5000
    const socket = io("https://localhost:5000", { auth: {
       token: user.access
    }});

		socket.on("connect", () => {
			console.log('+++ connected to server '); 
			console.log(socket.id); 
      dispatch({
        type: constants.SOCKETIO_ON_CONNECT,
        socket,
      });
    });
    
    socket.on("disconnect", () => {
			console.log('+++ connected to server '); 
			console.log(socket.id); 
      dispatch({
        type: constants.SOCKETIO_ON_DISCONNECT,        
      });
    });
   
    socket.on("connect_error", (err) => {
      console.log(err.message); 
      return;
    });

    socket.on("new execute time", (msg) => {
      console.log(msg); 
    });*/

    };
}

function disconnect() {
  return (dispatch, getState) => {
    const preio = getState().socketioStore.io;
    
    if(preio&&preio.connected) {
      preio.disconnect()
      dispatch({
        type: constants.SOCKETIO_DISCONNECT,      
      });
    } 
  };
}
